/* https://jquense.github.io/react-widgets/ */
/* https://www.npmjs.com/package/react-spinners */

import React, { Component } from 'react';

//import "react-widgets/styles.css";
import '../../index.css'
//import "react-widgets/scss/styles.scss";

//import NumberPicker from "react-widgets/NumberPicker";
import { InputNumber } from "primereact/inputnumber"
import "primereact/resources/themes/mira/theme.css"

import Combobox from "react-widgets/Combobox";
import DropdownList from "react-widgets/DropdownList";
import DatePicker from "react-widgets/DatePicker";
import Listbox from "react-widgets/Listbox";

import RadioButtons from "./RadioButtons";

import ClipLoader from "react-spinners/ClipLoader";

import { showPopopMessage } from "../../Components/PopupMessage/Toastify.js";
import { TYPE_MESSAGE_EXCEEDS_LENGTH, TYPE_MESSAGE_WRONG_CASE, TYPE_MESSAGE_UNAVAILABLE_SYMBOL } from "../../Components/PopupMessage/Toastify.js";
import { requestBase, apiroot } from "./Fetch-helpers";

export default class NotesFeatureItem extends Component {

    constructor(props) {
        super(props);
        this.handleClick = this.postData.bind(this);
        this.handleKeyDownText = this.handleKeyDownText.bind(this);
        this.handleKeyDownNumeric = this.handleKeyDownNumeric.bind(this);

        this.state = {
            waiting: false, posting: false, //value: this.props.feature.currentValue,
            timerOn: false, timerDuration: 0, timerTime: 0, valuefortimer: null,
        };
    }

    /**
     * Таймер
     * 
     */

    startTimer = (msDuration) => {
        this.setState({
            timerOn: true,
            timerTime: 0, //this.state.timerTime,
            timerDuration: msDuration //this.state.timerTime
        });
        this.timer = setInterval(() => {
            const newTime = this.state.timerTime + 10;
            if (newTime < this.state.timerDuration) {
                this.setState({
                    timerTime: newTime
                });
            } else {
                this.stopTimer();
                //alert("Countdown ended");
                //let val = this.validate(this.state.valuefortimer);
                this.setState({ waiting: true });

                this.postData();
            }
        }, 10);
    };
    stopTimer = () => {
        clearInterval(this.timer);
        this.setState({ timerOn: false, timerTime: 0 });
    };
    resetTimer = () => {
        if (this.state.timerOn === true) {
            this.setState({
                timerTime: 0 //this.state.timerStart
            });
        }
    };


    async postDataAsync(feature) {

        console.log("Выполняем PATCH для Notes...");
        console.log("Значение (" + feature.description + "): " + feature.currentValue);

        try {
            let response = await fetch(apiroot + "Notes"  /*feature.id*/,
                Object.assign({}, requestBase, {
                    method: "PATCH",
                    credentials: 'include',
                    headers: {
                        'Accept': 'application/json', //, text/plain
                        'Content-Type': 'application/json'//;charset=UTF-8
                    },
                    body: JSON.stringify(feature)
                }));

            if (!response.ok) {

                switch (response.status) {
                    case 599:

                        console.log("Повторно Get Configuration...");
                        await this.props.updateConfiguration(undefined, false, false, true);

                        console.log("Повторно PATCH...");
                        response = await fetch(apiroot + "Notes" /*+ (params.cfgid == null ? "" : params.cfgid)*/,
                            Object.assign({}, requestBase, {
                                method: "PATCH",
                                credentials: 'include',
                                headers: {
                                    'Accept': 'application/json', //, text/plain
                                    'Content-Type': 'application/json'//;charset=UTF-8
                                },
                                body: JSON.stringify(feature)
                            }));

                        break;
                    default:
                        const data = await response.json();
                        console.log(JSON.stringify(data));
                        //alert("Какая-то фигня! Смотри консоль...\nЕще можно нажать F5");
                        //this.setState({ posting: false });
                        return;
                }

                if (!response.ok) {
                    const data = await response.json();
                    console.log(JSON.stringify(data));
                    //this.setState({ posting: false });
                    return;
                }
            }

            console.log("PATCH отработал нормально");

            try {
                //this.setState({ waiting: true });
                const data = await response.json();
                //console.log(JSON.stringify(data));
                //this.setState({ Model: data, loading2: false });
                this.props.handleUpdate(data, feature.id);
                /*if (data.errorMessageString != null) {
                    alert(data.errorMessageString);
                }*/
            }
            finally {
                this.setState({ posting: false });
            }
        }
        catch (err) {
            this.props.showError(err);
        }
    }

    async postDataAsyncTry(feature) {
        try {
            this.props.handleLock(true);
            await this.postDataAsync(feature);
        }
        finally {
            this.props.handleLock(false);
        }
    }

    postData = () => {
        const feature = this.props.feature;

        feature.configurationId = this.props.configurationId;
        feature.NotesId = this.props.notesId;
        //feature.currentValue = this.state.value;

        this.setState({ waiting: false, posting: true });
        this.postDataAsyncTry(feature);
    }

    validate = (value) => {
        const feature = this.props.feature;
        switch (feature.type) {
            case "numericUpDown":
                feature.currentValue = value === null ? '' : String(value);
                break;
            case "textBox":
                feature.currentValue = String(value);
                break;
            case "comboBox":
                if (feature.values.filter((f) => f.id == value.id)[0].enable) {
                    if (feature.values.filter((f) => f.selected == true).length > 0) {
                        let prev_v = feature.values.filter((f) => f.selected == true);
                        if (prev_v.length > 0)
                            prev_v[0].selected = false;
                    }
                    //feature.values.filter((f) => f.selected == true)[0].selected = false;
                    feature.values.filter((f) => f.id == value.id)[0].selected = true;
                } else {
                    throw new Error('not valid');
                }
                break;
            case "dateTime":
                if (value != null && value != '') {
                    var dd = String(value.getDate()).padStart(2, '0');
                    var mm = String(value.getMonth() + 1).padStart(2, '0'); //January is 0!
                    var yyyy = value.getFullYear();
                    feature.currentValue = dd + "." + mm + "." + yyyy;
                } else {
                    feature.currentValue = null;
                }
                break;
            case "radio":
                if (feature.values.filter((f) => f.selected == true).length > 0)
                    feature.values.filter((f) => f.selected == true)[0].selected = false;
                feature.values.filter((f) => f.id == value.id)[0].selected = true;
                feature.currentValue = value.description;
                break;
            default:
                feature.currentValue = String(value);
        }

        return feature.currentValue;
    }

    changingValue = (value) => {
        try {
            let val = this.validate(value);
            //this.setState({ value: this.validate(value), waiting: true });
            //this.setState({ value: value, valuefortimer: value });

            if (!this.state.timerOn) {
                this.startTimer(1000);
            } else {
                this.resetTimer();
            }
        } catch { }
    }

    leavingControl = () => {
        if (this.state.timerOn) {
            this.stopTimer();
            this.postData();
        }
    }

    handleKeyDownNumeric(event) {
        if (event.key.length == 1 && "0123456789,.-".indexOf(event.key) === -1) {
            event.preventDefault();
            showPopopMessage("Необходимо ввести число!", TYPE_MESSAGE_UNAVAILABLE_SYMBOL);
            return;
        }

        //if (event.key.length == 1 && ",.".indexOf(event.key) != -1) {
        //    const currentValue = event.target.defaultValue;
        //    if (currentValue.indexOf('.') != -1 || currentValue.indexOf(',') != -1) {
        //        event.preventDefault();
        //        showPopopMessage("Необходимо ввести число!", TYPE_MESSAGE_UNAVAILABLE_SYMBOL);
        //        return;
        //    }
        //}

        //if (event.key.length == 1 && "-".indexOf(event.key) != -1) {
        //    const currentValue = event.target.defaultValue;
        //    // если '-' уже есть, и пытаются еще один ввести, то не даем
        //    if (currentValue.indexOf('-') != -1) {
        //        event.preventDefault();
        //        return;
        //    }
        //    // если пытаются ввести '-' не в начале числа, то не даем
        //    if (currentValue.length > 1 && event.target.selectionStart > 0) {
        //        event.preventDefault();
        //        return;
        //    }
        //}
    }

    handleKeyDownText(event) {
        const feature = this.props.feature;
        const currentValue = event.target.defaultValue; /*tag.lines.filter((l) => l.lineId == currentLineId)[0].value;*/
        const control = event.target;

        if (event.key.length == 1) {
            if (feature.characterCount > 0 && currentValue.length >= feature.characterCount) {
                if (control.selectionEnd - control.selectionStart == 0) {
                    event.preventDefault();
                    showPopopMessage("Максимум символов: " + feature.characterCount, TYPE_MESSAGE_EXCEEDS_LENGTH);
                    return;
                }
            }
        }

        if (feature.case == 1) {
            if (event.key == event.key.toUpperCase() && event.key != event.key.toLowerCase()) {
                event.preventDefault();
                //alert("Только нижний регистр!");
                showPopopMessage("Только нижний регистр!", TYPE_MESSAGE_WRONG_CASE);
                return;
            }
        }
        if (feature.case == 2) {
            if (event.key == event.key.toLowerCase() && event.key != event.key.toUpperCase()) {
                event.preventDefault();
                //alert("Только верхний регистр!");
                showPopopMessage("Только верхний регистр!", TYPE_MESSAGE_WRONG_CASE);
                return;
            }
        }
        if (event.key.length == 1 && feature.allowedCharacters != undefined && feature.allowedCharacters != '' && feature.allowedCharacters.indexOf(event.key) === -1) {
            event.preventDefault();
            //alert("Вы ввели недопустимый символ!\nРазрешенный набор: " + feature.allowedCharacters);
            showPopopMessage(<div>Вы ввели недопустимый символ!<p>Разрешенный набор: {`${feature.allowedCharacters}`}</p></div>, TYPE_MESSAGE_UNAVAILABLE_SYMBOL);
            return;
        }
    }

    render() {
        const feature = this.props.feature;
        const autoSize = this.props.autoSize;
        const enable = this.props.extDisable ? false : feature.enable;

        let titleValue = "";
        let titleStatus = "";

        const colorLoader = "white";
        let colorStatusClass = "";
        if (this.state.waiting) {
            colorStatusClass = "yellowlightOptFea";
            titleStatus = "";
        }
        if (this.state.posting) {
            colorStatusClass = "greyOptFea";
            titleStatus = "Параметр в процессе сохранения...";
        }
        if (!enable) {
            colorStatusClass = "greyOptFea";
            titleStatus = "Параметр недоступен для редактирования";
        } else {
            if (colorStatusClass == "") {
                colorStatusClass = feature.validate === true ? "grnOptFea" : "redOptFea";
                titleStatus = feature.validate === true ? "Параметр введен корректно" : "Значение параметра введено неверно";
            }
        }

        switch (feature.type) {
            case "label":
                return (
                    <div class="cdsFeatureItemHeaderComment">
                        <label className={'FeatureLabel'}>{feature.currentValue}</label>
                    </div>
                );
            case "numericUpDown":

                titleValue = "Диапазон допустимых значений: от " + feature.min + " до " + feature.max +
                    (this.props.difference != undefined && this.props.difference != '' ? "\n" + "Должен отличаться от параметра '" + this.props.differenceDescription + "' не меньше, чем на " + this.props.difference : "");

                return (
                    <div class="cdsFeatureItemHeaderComment">
                        <table>
                            <tbody>
                                <tr>
                                    <td title={titleStatus} className={`cdsFeatureItemHeaderComment ${colorStatusClass}`} >
                                        <div id={`${colorStatusClass}`} style={this.state.posting == true ? { display: "block" } : { display: "none" }}>
                                            <ClipLoader id={`${colorStatusClass}`}
                                                color={colorLoader}
                                                loading={this.state.posting}
                                                //cssOverride={override}
                                                size="12px"
                                                speedMultiplier="0.7"
                                                aria-label="Loading Spinner"
                                                data-testid="loader"
                                            />
                                        </div>
                                    </td>
                                    <td class="cdsFeatureItemHeaderComment" title={titleValue} >
                                        {/* {this.state.timerTime == 0 ? "" : 100 * Math.floor(1 + this.state.timerTime / 100) + "мс"}*/}
                                        {feature.description}
                                        <div className={`cdsFeatureItemHeaderContent
                                                ${(autoSize === 1 ? "autosizeByContent" : "")} 
                                                ${(feature.validate === undefined ? "rw-widget-unvalid" : "")}
                                                `}>

                                            <InputNumber
                                                showButtons
                                                locale="ru-RU"
                                                value={Number(typeof feature.currentValue == "string" ? feature.currentValue.replace(',', '.') : feature.currentValue)} //{Number(this.state.value.toString().replace(',', '.'))}
                                                onChange={e => this.changingValue(e.value)}
                                                disabled={!enable}
                                                step={feature.step}
                                                onKeyDown={this.handleKeyDownNumeric}
                                            />

                                            {/*<NumberPicker*/}
                                            {/*    //{...(this.state.waiting && { readOnly: true })}*/}
                                            {/*    //defaultValue={Number(this.props.feature.currentValue)}*/}
                                            {/*    value={Number(this.state.value.toString().replace(',', '.'))}*/}
                                            {/*    //max={feature.max}*/}
                                            {/*    //min={feature.min}*/}
                                            {/*    precision={feature.step}*/}
                                            {/*    messages={{*/}
                                            {/*        increment: `Увеличить на ${feature.step}`,*/}
                                            {/*        decrement: `Уменьшить на ${feature.step}`,*/}
                                            {/*    }}*/}
                                            {/*    onKeyDown={this.handleKeyDownNumeric}*/}
                                            {/*    onChange={value => this.changingValue(value)}*/}
                                            {/*    /*onBlur={value => this.leavingControl()}*/}
                                            {/*    readOnly={!enable}*/}

                                            {/*/>*/}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                );
            case "comboBox":
                let cb_values = feature.values;
                cb_values.sort((a, b) => Number(a.sequence.toString().replace(',', '.')) > Number(b.sequence.toString().replace(',', '.')) ? 1 : -1);
                cb_values = cb_values.filter((f) => f.visible == true);
                return (
                    <div class="cdsFeatureItemHeaderComment">
                        <table>
                            <tbody>
                                <tr>
                                    <td title={titleStatus} className={`cdsFeatureItemHeaderComment ${colorStatusClass}`} >
                                        <div id={`${colorStatusClass}`} style={this.state.posting == true ? { display: "block" } : { display: "none" }}>
                                            <ClipLoader id={`${colorStatusClass}`}
                                                color={colorLoader}
                                                loading={this.state.posting}
                                                //cssOverride={override}
                                                size="12px"
                                                speedMultiplier="0.7"
                                                aria-label="Loading Spinner"
                                                data-testid="loader"
                                            />
                                        </div>
                                    </td>
                                    <td class="cdsFeatureItemHeaderComment">
                                        {feature.description}
                                        <div className={`cdsFeatureItemHeaderContent ${(autoSize === 1 ? "autosizeByContent" : "")} ${(feature.validate === undefined ? "rw-widget-unvalid" : "")}`}>
                                            <DropdownList
                                                filter={false}
                                                /*hideEmptyPopup*/
                                                data={cb_values}
                                                dataKey='id'
                                                textField='description'
                                                value={cb_values.filter((f) => f.selected == true).length > 0 ? cb_values.filter((f) => f.selected == true)[0].id : ""}
                                                onChange={value => this.changingValue(value)}
                                                disabled={!enable}
                                                itemDisabled={item => !item.enable}
                                                renderListItem={({ item }) => (
                                                    <div className={`DropdownItem ${(item.enable ? "" : "Dropdowndisable")}`}>
                                                        <span >
                                                            {item.description}
                                                        </span>
                                                    </div>
                                                )}
                                            />
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                );
            case "textBox":

                if (feature.characterCount != undefined && feature.characterCount != '') {
                    titleValue = "Маскимальное количество символов: " + feature.characterCount;
                }

                return (
                    <div class="cdsFeatureItemHeaderComment">
                        <table>
                            <tbody>
                                <tr>
                                    <td title={titleStatus} className={`cdsFeatureItemHeaderComment ${colorStatusClass}`} >
                                        <div id={`${colorStatusClass}`} style={this.state.posting == true ? { display: "block" } : { display: "none" }}>
                                            <ClipLoader id={`${colorStatusClass}`}
                                                color={colorLoader}
                                                loading={this.state.posting}
                                                //cssOverride={override}
                                                size="12px"
                                                speedMultiplier="0.7"
                                                aria-label="Loading Spinner"
                                                data-testid="loader"
                                            />
                                        </div>
                                    </td>
                                    <td class="cdsFeatureItemHeaderComment" title={titleValue}>
                                        {feature.description}
                                        <div className={`cdsFeatureItemHeaderContent ${(autoSize === 1 ? "autosizeByContent" : "")} ${(feature.validate === undefined ? "rw-widget-unvalid" : "")}`}>
                                            <Combobox
                                                hideCaret
                                                hideEmptyPopup
                                                value={feature.currentValue}//{this.state.value}
                                                onKeyDown={this.handleKeyDownText}
                                                onChange={value => this.changingValue(value)}
                                                onBlur={value => this.leavingControl()}
                                                readOnly={!enable}
                                                placeholder={enable ? "Введите текстовое сообщение" : ""}
                                            />
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                );
            case "dateTime":
                let dtvalue = feature.currentValue; //this.state.value; //feature.currentValue;
                if (dtvalue == '') dtvalue = null;
                if (dtvalue != null && dtvalue != '') {
                    var parts = dtvalue.split('.');
                    if (parts.length === 3) {
                        dtvalue = new Date(parts[2], parts[1] - 1, parts[0]);
                    }
                } else {
                    //dtvalue = new Date();
                }

                return (
                    <div class="cdsFeatureItemHeaderComment">
                        <table>
                            <tbody>
                                <tr>
                                    <td title={titleStatus} className={`cdsFeatureItemHeaderComment ${colorStatusClass}`} >
                                        <div id={`${colorStatusClass}`} style={this.state.posting == true ? { display: "block" } : { display: "none" }}>
                                            <ClipLoader id={`${colorStatusClass}`}
                                                color={colorLoader}
                                                loading={this.state.posting}
                                                //cssOverride={override}
                                                size="12px"
                                                speedMultiplier="0.7"
                                                aria-label="Loading Spinner"
                                                data-testid="loader"
                                            />
                                        </div>
                                    </td>
                                    <td class="cdsFeatureItemHeaderComment">
                                        {feature.description}
                                        <div className={`cdsFeatureItemHeaderContent ${(autoSize === 1 ? "autosizeByContent" : "")} ${(feature.validate === undefined ? "rw-widget-unvalid" : "")}`}>
                                            <DatePicker
                                                value={dtvalue}
                                                //placeholder="ММ/ДД/ГГГГ"
                                                valueEditFormat={{ dateStyle: "short" }}
                                                valueDisplayFormat={{ dateStyle: "medium" }}
                                                messages={{
                                                    moveToday: "Сегодня",
                                                    moveBack: "Назад",
                                                    moveForward: "Вперед",
                                                    dateButton: "Выбор даты",
                                                }}
                                                onChange={value => this.changingValue(value)}
                                                //onBlur={value => this.leavingControl()}
                                                readOnly={!enable}
                                            />
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                );
            case "radio":
                let radioValues = feature.values;

                return (
                    <div class="cdsFeatureItemHeaderComment">
                        <table>
                            <tbody>
                                <tr>
                                    <td title={titleStatus} className={`cdsFeatureItemHeaderComment ${colorStatusClass}`} >
                                        <div id={`${colorStatusClass}`} style={this.state.posting == true ? { display: "block" } : { display: "none" }}>
                                            <ClipLoader id={`${colorStatusClass}`}
                                                color={colorLoader}
                                                loading={this.state.posting}
                                                //cssOverride={override}
                                                size="12px"
                                                speedMultiplier="0.7"
                                                aria-label="Loading Spinner"
                                                data-testid="loader"
                                            />
                                        </div>
                                    </td>
                                    <td class="cdsFeatureItemHeaderComment">
                                        {feature.description}
                                        <div class={`cdsFeatureItemHeaderContent ${autoSize === 1 ? "autosizeByContent" : ""}`}>
                                            <RadioButtons
                                                data={radioValues}
                                                onChange={value => this.changingValue(value)}
                                                readOnly={!enable}
                                            />
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                );

            default:
                return '';
        }
    }
}